<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.1782 3.95111C10.5061 3.34964 11.4938 3.34962 11.8218 3.95111L14.0117 7.96334L18.0122 10.1562C18.3132 10.3208 18.4998 10.6373 18.5 10.9809L18.4912 11.1084C18.4514 11.4014 18.2756 11.6614 18.0122 11.8056L14.0117 14L11.8218 18.0107C11.6578 18.3123 11.3424 18.5 11 18.5L10.8726 18.4912C10.5806 18.4511 10.3215 18.2744 10.1782 18.0107L7.98828 14L3.98779 11.8056C3.68673 11.6408 3.5 11.3245 3.5 10.9809C3.50014 10.6373 3.68676 10.3208 3.98779 10.1562L7.98828 7.96334L10.1782 3.95111ZM9.70069 8.89791L9.42676 9.39889L8.92578 9.67282L6.53955 10.9809L8.92578 12.2905L9.42676 12.5644L11 15.4473L12.5732 12.5644L13.0742 12.2905L15.459 10.9809L13.0742 9.67282L12.5732 9.39889L12.2993 8.89791L11 6.5146L9.70069 8.89791Z"
      fill="url(#paint0_linear_14506_120859)" />
    <path
      d="M19.8019 3.90772L18.6914 3.29816L18.0836 2.18367C17.9506 1.93878 17.5493 1.93878 17.4163 2.18367L16.8085 3.29816L15.698 3.90772C15.5758 3.97487 15.5 4.10328 15.5 4.24268C15.5 4.38226 15.5758 4.51067 15.698 4.5776L16.8085 5.18701L17.4163 6.30151C17.4828 6.42397 17.611 6.5 17.75 6.5C17.8889 6.5 18.0171 6.42397 18.0836 6.30151L18.6915 5.18701L19.802 4.5776C19.9242 4.5107 20 4.3823 20 4.24268C20 4.10328 19.9242 3.97487 19.8019 3.90772Z"
      fill="url(#paint1_linear_14506_120859)" />
    <path
      d="M6.30193 17.4077L5.19143 16.7982L4.58359 15.6837C4.45057 15.4388 4.04932 15.4388 3.91633 15.6837L3.30853 16.7982L2.19803 17.4077C2.07579 17.4749 2 17.6033 2 17.7427C2 17.8823 2.07579 18.0107 2.19803 18.0776L3.30853 18.687L3.91633 19.8015C3.98283 19.924 4.11104 20 4.24998 20C4.38893 20 4.5171 19.924 4.58363 19.8015L5.19147 18.687L6.30197 18.0776C6.42421 18.0107 6.5 17.8823 6.5 17.7427C6.49996 17.6033 6.42418 17.4749 6.30193 17.4077Z"
      fill="url(#paint2_linear_14506_120859)" />
    <defs>
      <linearGradient id="paint0_linear_14506_120859" x1="11" y1="3.5" x2="11" y2="18.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF" />
        <stop offset="1" stop-color="#D62FA0" />
      </linearGradient>
      <linearGradient id="paint1_linear_14506_120859" x1="17.75" y1="2" x2="17.75" y2="6.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF" />
        <stop offset="1" stop-color="#D62FA0" />
      </linearGradient>
      <linearGradient id="paint2_linear_14506_120859" x1="4.25" y1="15.5" x2="4.25" y2="20"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF" />
        <stop offset="1" stop-color="#D62FA0" />
      </linearGradient>
    </defs>
  </svg>

</template>

<script>
</script>